import { render, staticRenderFns } from "./creatLabel.vue?vue&type=template&id=52880da6&scoped=true"
import script from "./creatLabel.vue?vue&type=script&lang=js"
export * from "./creatLabel.vue?vue&type=script&lang=js"
import style0 from "./creatLabel.vue?vue&type=style&index=0&id=52880da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52880da6",
  null
  
)

export default component.exports